<homey-lotteries-dialog-content
  [singleDescription]="'One of your applications has been selected for further review! Please check your emails at ' + userEmail() + ' on how to proceed.'"
  [multipleDescription]="'Some of your applications have been selected for further review! Please check your emails at ' + userEmail() + ' on how to proceed.'"
  singleTitle="Application selected!"
  multipleTitle="Applications selected!"
  [notification]="data()"
  [closeButton]="closeButton()"
>
  <ng-template lotteryDialogListItem let-lottery>
    <homey-lottery-list-item [apartment]="lottery" [openInPopup]="true">
      <p>Selected</p>
    </homey-lottery-list-item>
  </ng-template>
</homey-lotteries-dialog-content>
